/**
 * InterestsScreen — grid-pick, then confirm.
 *
 * Single card showing all interests in a 2-col grid.
 * Tap toggles. Continue unlocks when at least one is selected.
 */
import { Button } from "../components/Button";
import { INTEREST_OPTIONS } from "../domain/questionnaireOptions";
import { useFlow } from "../flow/FlowContext";
import { useT } from "../i18n";
import { QuestionCard } from "../components/QuestionCard";

export function InterestsScreen() {
  const { profileAnswers, setProfileAnswers, next, canContinue } = useFlow();
  const t = useT();
  const selected = profileAnswers.interests;

  const toggle = (code: string) => {
    setProfileAnswers((p) => {
      const on = !p.interests.includes(code);
      const nextList = on
        ? [...p.interests, code]
        : p.interests.filter((c) => c !== code);
      return { ...p, interests: nextList };
    });
  };

  return (
    <div className="screen-enter" style={{ flex: 1, overflowY: "auto" }}>
      <QuestionCard
        question={t("interests.title")}
        subtext={t("interests.text")}
      >
        <div className="q-interests">
          {INTEREST_OPTIONS.map((o) => (
            <button
              key={o.code}
              type="button"
              className={`q-interest-btn${selected.includes(o.code) ? " is-selected" : ""}`}
              onClick={() => toggle(o.code)}
              aria-pressed={selected.includes(o.code)}
            >
              {t(`options.interest.${o.code}`)}
            </button>
          ))}
        </div>
      </QuestionCard>
      <div className="shell__footer" style={{ paddingLeft: 0, paddingRight: 0 }}>
        <Button onClick={next} disabled={!canContinue}>
          {t("questionnaire.confirm")}
        </Button>
      </div>
    </div>
  );
}
